/**
 * KAN-956/KAN-964: "Встречи и перезвоны" (дашборд кабинета и вкладка "Встречи" в /m):
 * шаги выбранного дня и число шагов по дням месяца для календаря.
 * Ключи вложены в ATTENTION_QUERY_KEY: действия строк внимания обновляют и список, и календарь.
 */
import { useQuery } from '@tanstack/react-query'
import { TODAY_STEPS_MONTH_QUERY_KEY, TODAY_STEPS_QUERY_KEY } from '@/services/api/queryKeys'
import { todayStepsApi, type TodayStepsList, type TodayStepsMonth } from '@/services/api/todaySteps'

/** Обновление раз в минуту: просрочка и новые шаги появляются без перезагрузки. */
const REFRESH_MS = 60_000

/** Шаги дня ГГГГ-ММ-ДД; null: сегодня по поясу организации. */
export function useTodaySteps(date: string | null = null) {
  return useQuery<TodayStepsList>({
    queryKey: [...TODAY_STEPS_QUERY_KEY, 'day', date ?? 'today'],
    queryFn: () => todayStepsApi.list(date ?? undefined),
    refetchInterval: REFRESH_MS,
  })
}

/** Число шагов по дням месяца ГГГГ-ММ. */
export function useTodayStepsMonth(month: string) {
  return useQuery<TodayStepsMonth>({
    queryKey: [...TODAY_STEPS_MONTH_QUERY_KEY, month],
    queryFn: () => todayStepsApi.month(month),
    refetchInterval: REFRESH_MS,
  })
}
